import React, { Fragment } from "react";
import InputCard from "../../common/InputCard";

class CardsLayout extends React.Component {
  state = {};
  constructor() {
    super();
    this.cardsLayout = [
      // cards
      {
        title: "Dimensions",
        items: [
          {
            label: {
              value: "Cubic Feet",
              size: "70%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "cubicFeet"
            },
            readOnly: true,
            size: "50%"
          },
          {
            label: {
              value: "Cases Per Tier",
              size: "70%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "casesPerTier"
            },
            size: "50%"
          },
          {
            label: {
              value: "Units Per Case",
              size: "70%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "unitsPerCase"
            },
            size: "50%"
          },
          {
            label: {
              value: "Tiers Per Pallet",
              size: "70%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "tiersPerPallet"
            },
            size: "50%"
          }
        ]
      },
      {
        title: "INFOREM Info",
        items: [
          {
            label: {
              value: "Profile ID",
              size: "70%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "profileID"
            },
            size: "50%",
            readOnly: true
          },
          {
            label: {
              value: "DSER",
              size: "70%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "DSER"
            },
            size: "50%",
            readOnly: true
          },
          {
            label: {
              value: "Profile Year",
              size: "70%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "profileYear"
            },
            size: "50%",
            readOnly: true
          },
          {
            label: {
              value: "Init DESEAS Demand",
              size: "70%",
              fontSize: "85%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "initDESEASDemand"
            },
            size: "50%",
            readOnly: true
          }
        ]
      },
      {
        title: "Vendor Conversion",
        items: [
          {
            label: {
              value: "Factor",
              size: "70%"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "factor"
            },
            size: "50%"
          },
          {
            label: {
              value: "Action (* OR /)",
              size: "70%"
            },
            item: {
              node: "input",
              type: "string",
              value: "",
              intemName: "action",
              filter: "[^/*]" /* only allow / or **/,
              maxLength: 1
            },
            size: "50%",
            readOnly: true
          },
          {
            label: {
              value: "Company POQ Multiple",
              size: "77.5%",
              maxWidth: "216px"
            },
            item: {
              node: "input",
              type: "number",
              value: "",
              intemName: "companyPOQMultiple"
            },
            size: "65.5%"
          }
        ]
      }
    ];
  }

  componentDidMount() {
    this.setState({ layout: this.cardsLayout });
  }

  formatData = props => {
    if (props) {
      this.cardsLayout.map((card, c) => {
        const inputName = Object.keys(props[c])[0];

        card.items.map((item, i) => {
          if (item.item.intemName === props[c][inputName][i].name) {
            item.item.value =
              props[c][inputName][i].value === undefined ||
              props[c][inputName][i].value === "" ||
              props[c][inputName][i].value === false
                ? ""
                : props[c][inputName][i].value;
            item.item.obj = props[c][inputName][i].obj;
            item.item.span = props[c][inputName][i].span;
            item.label.value = props[c][inputName][i].label;
          }
          return null;
        });
        return null;
      });
    }
    return null;
  };
  getCardsInfo = (info, title) => {
    this.props.setCardsInfo({ [title]: info });
  };
  renderCards = () => {
    this.formatData(this.props.cardsData);
    const card = this.cardsLayout.map((card, key) => {
      return (
        <div key={key} style={{ flex: 1 }}>
          <InputCard jsonObj={card} setCardsInfo={this.getCardsInfo} />
        </div>
      );
    });
    return <Fragment>{card}</Fragment>;
  };

  render() {
    return (
      <Fragment>
        <div className="cards-container" style={{ display: "flex" }}>
          {this.renderCards()}
        </div>
      </Fragment>
    );
  }
}
export default CardsLayout;
